import {
  BMComponentsType,
  BMPrimitives,
  BMSkeletonLoader,
  useBMTheme,
} from "@traveloka/district-bloom";
import { ScrollView, StyleSheet } from "react-native";
import BMView from "../../../../../components/View/BMView";

const LOADER_ARRAY = [0, 0, 0]; //Repeat loader three times
const LEFT_COLLUMN_WIDTH = 247;
const RIGHT_COLLUMN_WIDTH = 80;

export default function SearchResultLoader() {
  const { BMComponents } = useBMTheme();
  const styles = createStyles(BMComponents);
  return (
    <ScrollView style={styles.scrollView}>
      {LOADER_ARRAY.map((_, index) => (
        <BMView key={index} row justify="between" style={styles.container}>
          <BMView spacing="xs">
            <BMSkeletonLoader height={20} width={LEFT_COLLUMN_WIDTH} />
            <BMSkeletonLoader height={16} width={LEFT_COLLUMN_WIDTH} />
          </BMView>
          <BMView align="center" spacing="xs">
            <BMSkeletonLoader height={16} width={RIGHT_COLLUMN_WIDTH} />
            <BMSkeletonLoader height={20} width={RIGHT_COLLUMN_WIDTH} />
          </BMView>
        </BMView>
      ))}
    </ScrollView>
  );
}

const createStyles = (BMComponents: BMComponentsType) =>
  StyleSheet.create({
    scrollView: {
      paddingHorizontal: BMPrimitives.BMSize.lg,
      marginTop: BMPrimitives.BMSize.lg,
    },
    container: {
      borderBottomColor: BMComponents.BMStyleTextInkPrimaryInvert,
      borderBottomWidth: BMPrimitives.BMStroke.sm,
      paddingBottom: BMPrimitives.BMSize.sm,
      marginTop: BMPrimitives.BMSize.sm,
    },
    text: {
      width: 247,
      overflow: "hidden",
    },
  });
